import { useEffect } from 'react';
import { motion } from 'framer-motion';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { ArrowRight } from 'lucide-react';

export default function Transport() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen bg-background text-foreground">
      <Navbar />

      {/* HERO */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        className="relative h-[600px] mb-0 overflow-hidden"
      >
        <img
          src="https://media.base44.com/images/public/69cd72579c1c23d07f425ea3/3bd6c37ff_d38bc4a79_Transport_House_Nomad35.jpg"
          alt="Transport badstue"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/10 to-black/20"></div>
        <div className="absolute inset-0 flex flex-col justify-end p-12 z-10">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
            <p className="text-sm tracking-widest-2xl font-body uppercase text-white/60 mb-6">Artikkel 6</p>
            <h1 className="font-heading text-6xl md:text-7xl lg:text-8xl font-light leading-[1.0] text-white mb-6">
              Transport
            </h1>
            <p className="font-body text-white/80 text-xl max-w-2xl leading-relaxed">
              Logistikk og sikker frakt av din badstue fra fabrikk til stedet ditt
            </p>
          </motion.div>
        </div>
      </motion.div>

      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <motion.section
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="py-20"
        >
          <div className="max-w-4xl">
            <h2 className="font-heading text-5xl font-light leading-[1.1] mb-8 text-[#2a1810]">
              Fra produksjon til montasje
            </h2>
            <p className="font-body text-2xl text-foreground/70 leading-relaxed mb-6">
              En badstue er et større prosjekt som krever nøye planlegging fra start til slutt. Vi håndterer all logistikk og sikrer at badstuen din ankommer i perfekt stand, uansett hvor du befinner deg i Norge eller Europa.
            </p>
            <p className="font-body text-2xl text-foreground/70 leading-relaxed mb-12">
              Vår erfaring med transport sikrer at hver badstue behandles med omhu. Fra pakking på fabrikken til levering på stedet, vi administrerer hele prosessen.
            </p>

            <div className="grid md:grid-cols-2 gap-6 mb-16">
              {[
                { 
                  title: 'Nøye pakking',
                  desc: 'Badstuen pakkes med spesialisert materiale for å beskytte alle komponenter under transport.' 
                },
                { 
                  title: 'Sikker lastering',
                  desc: 'Vi bruker godkjente hjelpemidler og erfarne transportører for sikker lasting og lossing.' 
                },
                { 
                  title: 'Ruting og tidsplan',
                  desc: 'Vi koordinerer med deg om best mulig tidspunkt og rute til ditt sted.' 
                },
                { 
                  title: 'Dokumentasjon',
                  desc: 'Alle leveranser dokumenteres og du får løpende informasjon om status.' 
                }
              ].map((item, idx) => (
                <motion.div
                  key={idx}
                  whileHover={{ y: -4 }}
                  className="bg-white border border-border/20 rounded-[8px] p-8 hover:border-[#2d5a3d] hover:shadow-md transition-all"
                >
                  <h3 className="font-heading text-lg font-light text-[#2a1810] mb-3">{item.title}</h3>
                  <p className="font-body text-2xl text-foreground/70">{item.desc}</p>
                </motion.div>
              ))}
            </div>

            <div className="bg-gradient-to-br from-[#2d5a3d]/10 to-transparent border-l-4 border-[#2d5a3d] rounded-[8px] p-8 mb-12">
              <h3 className="font-heading text-lg font-light text-[#2a1810] mb-3">Prosess</h3>
              <ul className="space-y-2 font-body text-2xl text-foreground/70">
                <li>• Ferdigprodusert badstue pakkes på fabrikken</li>
                <li>• Transport ordnes i samarbeid med spesialiserte frakt­selskaper</li>
                <li>• Du mottar løpende informasjon om leveringen</li>
                <li>• Badstuen losses og plasseres på stedet ditt</li>
                <li>• Montasje og utfinaliseringer gjennomføres</li>
              </ul>
            </div>

            <motion.a
              whileHover={{ scale: 1.02 }}
              href="/laer-mer-handverk"
              className="inline-flex items-center gap-2 px-8 py-4 bg-[#2a1810] text-white font-body tracking-widest text-sm font-semibold rounded-[4px] hover:bg-[#2a1810]/90 transition-all"
            >
              Tilbake til Lær Mer <ArrowRight size={16} />
            </motion.a>
          </div>
        </motion.section>
      </div>

      <Footer />
    </div>
  );
}